import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import rootReducer from './reducers/rootReducer';

export default () =>  {
    return createStore (rootReducer, 
        applyMiddleware(thunk, logger));
}
